module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Checking_Black.61bf7435.svg";